import { last } from 'lodash';

import { focusedElementSelector } from '@app/constants';

interface SetFocusOnProps {
  selector?: string;
  element?: HTMLElement | null;
}

export const setFocusOn = ({
  selector = focusedElementSelector,
  element,
}: SetFocusOnProps = {}) => {
  const elementToFocus: HTMLElement | undefined =
    element || last(document.querySelectorAll(selector));

  if (elementToFocus) {
    elementToFocus.focus();
  }
};
